// extracted by mini-css-extract-plugin
export default {"icon":"Spinner_icon__+pDQg","icon-rotation":"Spinner_icon-rotation__wxukB"};